import ModalCoachCancelPrompt from './ModalCoachCancelPrompt';

export { type Props } from './ModalCoachCancelPrompt';

export default ModalCoachCancelPrompt;
